import React, { useCallback, useState } from 'react';
import { Text, Button, Stack, Overlay } from '@moda/om';
import { reportError } from '../../../../lib/reportError';
import { useUpdateOrderShippingAddress } from '../../../../hooks/useUpdateOrderShippingAddress';
import { useOrderSummary } from '../../../../hooks/useOrderSummary';
import { useErrorModal } from '../../../../hooks/useErrorModal';
import { LoadingBalls } from '../../../LoadingBalls';
import { ModalOverlay } from '../../../Modal';
import { useOrderDetails } from '../../../OrderDetails';
import './OrderDetailsShippingAddressConfirmation.scss';

interface Props {
  show: boolean;
  onClose: () => void;
  onProceed: () => void;
}

export const OrderDetailsShippingAddressConfirmation: React.FC<Props> = ({
  show,
  onClose,
  onProceed
}) => {
  const { orderNumber, orderSummary } = useOrderDetails();
  const [canceling, setCanceling] = useState(false);
  const { showErrorModal } = useErrorModal();
  const { refetch } = useOrderSummary(orderNumber);
  const { loading: updatingOrderShippingAddress } = useUpdateOrderShippingAddress(orderNumber);

  const handleCancel = useCallback(() => {
    setCanceling(true);
    refetch()
      .then(() => {
        onClose();
        setCanceling(false);
      })
      .catch(error => {
        reportError(error);
        onClose();
        showErrorModal();
      });
  }, [refetch, onClose, showErrorModal]);

  if (!orderSummary) return null;

  const { taxAndShippingChanges } = orderSummary.attributes;

  return (
    <ModalOverlay className="OrderDetailsShippingAddressConfirmation" onClose={onClose} show={show}>
      <div className="OrderDetailsShippingAddressConfirmation__content">
        <Stack space={6}>
          <Text treatment="h4" family="serif">
            {taxAndShippingChanges.message}
          </Text>

          <Stack alignItems="center" space={4}>
            <Button onClick={onProceed}>Yes, Proceed</Button>

            <Button onClick={handleCancel} secondary>
              Cancel
            </Button>
          </Stack>
        </Stack>
        <Overlay show={canceling || updatingOrderShippingAddress}>
          <LoadingBalls />
          <Text treatment="eyebrow">Saving</Text>
        </Overlay>
      </div>
    </ModalOverlay>
  );
};
